import { createContext, useContext } from 'react';

export interface UnreadMessagesContextProps {
  hasUnreadCount: boolean;
  refreshUnreadCount: () => Promise<void>;
}

const UnreadMessagesContext = createContext<
  UnreadMessagesContextProps | undefined
>(undefined);

export function useUnreadMessages() {
  const context = useContext(UnreadMessagesContext);
  if (context === undefined) {
    throw new Error(
      'useUnreadMessages must be used within an UnreadMessagesProvider'
    );
  }
  return context;
}

export default UnreadMessagesContext;
